import { Component, OnInit } from '@angular/core';
import { AutomationService } from '../automation.service';

@Component({
    selector: 'automation-administration',
    templateUrl: './automation-administration.component.html',
    styleUrls: ['./automation-administration.component.css']
})
export class AutomationAdministrationComponent implements OnInit {

    public sheets: any[] = [];

    public password: string = '';

    public errorOverLay = null;

    constructor(private automationService: AutomationService) { }

    public ngOnInit() {

    }

    public setPassword() {

        if (this.password.trim()) {

            this.automationService.password = this.password;

            this.errorOverLay = {
                message: 'Password is saved successfully',
                success: true
            };

            this.password = '';
        } else {

            this.errorOverLay = {
                message: 'No password to set',
            };
        }

    }

    public removeRolledBackProcesses() {

        this.automationService.registerSpinner.next(true);

        this.automationService.removeRolledBackProcesses()
            .subscribe((data) => {

                this.automationService.registerSpinner.next(false);

                if (data && data.n > 0) {

                    this.errorOverLay = {
                        message: data.n + ' Processes are removed successfully',
                        success: true
                    };
                } else {
                    this.errorOverLay = {
                        message: 'There are no rolled back processes to remove',
                    };
                }

            }, (error) => {

                if (error.json) {

                    this.errorOverLay = {
                        message: error.json().message
                    };
                }

                this.automationService.registerSpinner.next(false);
            });
    }

    public closeOverLay() {

        this.errorOverLay = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/automation/automation-administration/automation-administration.component.ts